import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home')
    },
    {
        path: '/Artikel',
        name: 'Artikel',
        component: () => import('@/components/Article/ArticleList'),
    },
    {
        path: '/Artikel/Neu',
        name: 'Artikel New',
        component: () => import('@/components/Article/ArticleEdit'),
        props: { create: true }
    },
    {
        path: '/Artikel/:articleId',
        name: 'ArtikelEdit',
        component: () => import('@/components/Article/ArticleEdit'),
        props: { create: false }
    },
    {
        path: '/Kalender/Neu',
        name: 'Kalender Create',
        component: () => import('@/components/Calendar/Calendar/CalendarEdit'),
        props: { create: true }
    },
    {
        path: '/Kalender/:calendarId',
        name: 'Kalender Edit',
        component: () => import('@/components/Calendar/Calendar/CalendarEdit')
    },
    {
        path: '/Termine',
        name: 'Termine',
        component: () => import('@/components/Calendar/CalendarIndex')
    },
    {
        path: '/Termine/Neu',
        name: 'Termine Create',
        component: () => import('@/components/Calendar/Event/EventEdit'),
        props: { create: true }
    },
    {
        path: '/Termine/:eventId',
        name: 'Termine Edit',
        component: () => import('@/components/Calendar/Event/EventEdit')
    },
    {
        path: '/Entschuldigungen',
        name: 'Entschuldigungen',
        component: () => import('@/components/Excuse/ExcuseList')
    },
    {
        path: '/Entschuldigungen/drucken',
        name: 'Entschuldigungen Drucken',
        component: () => import('@/components/Excuse/ExcusePrintView')
    },
    {
        path: '/Entschuldigung/:excuseId',
        name: 'Entschuldigungen Edit',
        component: () => import('@/components/Excuse/ExcuseView')
    },
    {
        path: '/Hinweise',
        name: 'Hinweise',
        component: () => import('@/components/Warning/WarningList')
    },
    {
        path: '/Hinweis/Neu',
        name: 'Hinweis Neu',
        component: () => import('@/components/Warning/WarningEdit'),
        props: { create: true }
    },
    {
        path: '/Hinweis/:warningId',
        name: 'Hinweis Edit',
        component: () => import('@/components/Warning/WarningEdit'),
        props: { create: false }
    },
    {
        path: '/Navigation',
        name: 'Navigation',
        component: () => import('@/components/CMS/Navigation/NavigationList')
    },
    {
        path: '/Navigation/Dropdown/:dropdownId',
        name: 'Dropdown Edit',
        component: () => import('@/components/CMS/Navigation/DropdownEdit')
    },
    {
        path: '/Dropdown/:dropdownId/Seiten',
        name: 'Site',
        component: () => import('@/components/CMS/Site/SiteList')
    },
    {
        path: '/Seite/:siteId',
        name: 'Site Edit',
        component: () => import('@/components/CMS/Site/SiteEdit')
    },
    {
        path: '/:siteId/Sektionen',
        name: 'Section',
        component: () => import('@/components/CMS/Section/SectionList')
    },
    {
        path: '/Sektion/:sectionId',
        name: 'Section Edit',
        component: () => import('@/components/CMS/Section/SectionEdit')
    },
    {
        path: '/Schnellzugriffe',
        name: 'Schnellzugriffe',
        component: () => import('@/components/QuickAccess/QuickAccessList')
    },
    {
        path: '/Schnellzugriff/:quickAccessId',
        name: 'Schnellzugriff',
        component: () => import('@/components/QuickAccess/QuickAccessEdit')
    },
    {
        path: '/Benutzer',
        name: 'Users',
        component: () => import('@/components/User/UserList')
    },
    {
        path: '/Benutzer/:userId',
        name: 'User',
        component: () => import('@/components/User/UserEdit')
    },
    {
        path: '/Einladung/Neu',
        name: 'Einladung Erstellen',
        component: () => import('@/components/Invitation/InvitationEdit'),
        props: { create: true }
    },
    {
        path: '/Einladung/:invitationId',
        name: 'Einladung',
        component: () => import('@/components/Invitation/InvitationEdit')
    },{
        path: '/Registrieren',
        name: 'Registrierung',
        component: () => import('@/components/Message/Error'),
        props: { message: "Sie sind bereits registriert." }
    },
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

export default router
